import ApiService from "@/base/api/api.service"

import {
    GET_FOLLOWING_LIST
} from "@/store/actions.type"

import {
    PUSH_FOLLOWING,
    SET_ERROR
} from "@/store/mutations.type"

import {
    GET_USER_URL
} from "@/base/api/config";

const StateKey = 'profileFollowing'

export default {
    async [GET_FOLLOWING_LIST]({ commit, state }, payload) {
        try {
            const res = await ApiService.get(GET_USER_URL,
                `${payload.userId}/following?offset=${state[StateKey + 'Offset']}&limit=${state[StateKey + 'Limit']}`)
            commit(PUSH_FOLLOWING, res.data.users)
        } catch (err) {
            commit(SET_ERROR, err.data)
        }
    }
}